import React from "react";
import { X, ArrowLeft } from "lucide-react";
import PrivacyPolicy from "./PrivacyPolicy.jsx";
import TermsText from "./TermsText.jsx";

const Doc = ({ doc, showBusiness }) => (doc === "terms" ? <TermsText showBusiness={showBusiness} /> : <PrivacyPolicy showBusiness={showBusiness} />);

// A reader that opens on top of whatever the person is doing (for example the sign-up form), so they don't lose their place.
export default function LegalModal({ doc, showBusiness = true, onClose, onSwitch }) {
  return (
    <div className="overlay-backdrop fixed inset-0 z-[70] flex items-end lg:items-center justify-center" role="dialog" aria-modal="true" aria-label={doc === "terms" ? "Terms and Conditions" : "Privacy Policy"}>
      <div className="bg-card2 w-full max-w-2xl rounded-t-3xl lg:rounded-3xl flex flex-col" style={{ maxHeight: "92vh" }}>
        <div className="flex items-center gap-2 px-5 pt-4 pb-3 border-b border-hair">
          <div className="flex gap-2 flex-1">
            {[["privacy", "Privacy Policy"], ["terms", "Terms & Conditions"]].map(([k, l]) => (
              <button key={k} onClick={() => onSwitch?.(k)} className="rounded-full px-3 py-1.5 text-xs font-medium" style={{ background: doc === k ? "var(--brass-dim)" : "var(--card)", color: doc === k ? "var(--brass)" : "var(--ivory-dim)" }}>{l}</button>
            ))}
          </div>
          <button onClick={onClose} aria-label="Close" className="p-1"><X size={18} className="text-ivory-dim" /></button>
        </div>
        <div className="overflow-y-auto px-5 pb-8 pt-3"><Doc doc={doc} showBusiness={showBusiness} /></div>
      </div>
    </div>
  );
}

// The same documents as a normal web page, for the public addresses  /#/privacy  and  /#/terms
// (the links to give app stores, payment providers and the sign-up screen).
export function LegalPage({ doc }) {
  return (
    <div className="px-5 pt-8 pb-16">
      <a href="#/" onClick={(e) => { e.preventDefault(); window.location.hash = ""; }} className="inline-flex items-center gap-1.5 text-xs text-ivory-dim mb-4"><ArrowLeft size={14} /> Back to the app</a>
      <div className="flex gap-2 mb-4">
        {[["privacy", "Privacy Policy", "#/privacy"], ["terms", "Terms & Conditions", "#/terms"]].map(([k, l, h]) => (
          <a key={k} href={h} className="rounded-full px-3 py-1.5 text-xs font-medium" style={{ background: doc === k ? "var(--brass-dim)" : "var(--card)", color: doc === k ? "var(--brass)" : "var(--ivory-dim)" }}>{l}</a>
        ))}
      </div>
      <Doc doc={doc} showBusiness />
    </div>
  );
}
